export interface LoadScriptOptions {
  callback?: () => void
  defer?: boolean
  id: string
  src: string
}

/**
 * Used for performance, when we don't want to add unnecessary scripts to
 * index.html head that ultimately slow down the speed of the app. With this
 * helper function we can load the scripts only when the components need them
 *
 * @param {func} callback a callback used to let component know script is loaded
 * @param {bool} defer if we want to defer the downloading till after UI is rendered
 * @param {string} id a string to identify the scripts that we're adding
 * @param {string} src the url of the script we're downloading
 */
export const loadScript = ({
  callback,
  defer = false,
  id,
  src,
}: LoadScriptOptions) => {
  const existingScript = document.getElementById(id)

  if (!existingScript) {
    // Need to create as an HTMLScriptElement to access the defer property
    const script = document.createElement('script') as HTMLScriptElement
    script.id = id
    script.src = src
    script.defer = defer
    script.onload = () => callback && callback()

    document.head.appendChild(script)
  }

  // sometimes the script is already loaded, so we just need to call the
  // callback and make sure whatever just tried to add the script knows
  // it loaded (or thinks it just did).
  if (existingScript && callback) callback()
}
